import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import DataWrapper from '../DataWrapper'
import Translations from '../TranslationsWrapper'
import FavouritesWrapper from '../FavouritesWrapper'
import { configureUrlQuery } from 'react-url-query'
import { compose } from 'recompose'
import { Provider } from 'rebass'
import { elementId } from './config'

import history from './history'
import theme from '../theme'

configureUrlQuery({ history })

const EnhancedApp = compose(
  DataWrapper(elementId),
  Translations(elementId),
  FavouritesWrapper
)(App)

// init
const element = document.getElementById(elementId)
if (element) {
  ReactDOM.render(
    <Provider theme={theme}>
      <EnhancedApp />
    </Provider>,
    element
  )
}
